<div class="nugget-container">
  @if (nugget().context) {
    <h2 class="nugget-title">{{ nugget().title }}</h2>
  }
  <div
    class="nugget-content"
    [class.has-columns]="nugget().context && nugget().img"
    [class.order-reversed]="nugget().imageOnTheLeft"
  >
    <div class="content-wrapper">
      @if (nugget().img) {
        <button class="nugget-image" (click)="openImage(nugget().img)">
          <img [src]="nugget().img | base64ToImage" [alt]="nugget().title" />
        </button>
      }
      @if (nugget().context) {
        <div class="nugget-context">
          <div [innerHTML]="nugget().context | safeHtml" class="nugget-text"></div>
        </div>
      }
    </div>
  </div>
</div>
